import { Ref, shallowRef } from 'vue'
import cloneDeep from 'lodash/cloneDeep'

export default abstract class BaseCachedDataService<T> {
    protected _data: Ref<T>
    private readonly defaultData: T

    protected constructor (defaultData: T) {
        this.defaultData = cloneDeep(defaultData)
        this._data = shallowRef(cloneDeep(defaultData)) as Ref<T>
    }

    get dataRef (): Readonly<Ref<T>> {
        return this._data
    }

    set data (data: T) {
        this._data.value = data
    }

    get data (): T {
        return this._data.value
    }

    abstract loadData(id?: number): Promise<T>


    clearData (): void {
        this._data.value = cloneDeep(this.defaultData)
    }
}
